import React, { useContext, useEffect, useState } from 'react';
import { useParams, useOutletContext } from 'react-router-dom';

import Metrics from '../metrics/metrics';
import Comments from '../comments/comments';

import { CustomerContext } from '../../../contexts/customer-context';
import { formatDateForDisplay } from '../../../helpers/date-time';

import Tile from '../../../component-library/tile';

const About = () => {
	const { data, storefrontData, uiGeneralConfig } = useOutletContext();
	const { id } = useParams();
	const {
		refDatas = {},
	} = useContext(CustomerContext);
	const [owners, setOwners] = useState([]);

	const getOwner = owner => {
		if (owners.find(item => item.code === owner)) {
			const ownerLabel = owners.find(item => item.code === owner).name;
			return ownerLabel;
		}

		return owner;
	};

	useEffect(() => {
		const newOwners = refDatas.find(item => item.code === 'Owner');
		setOwners(newOwners.refdatalist);
	}, []);

	return (
		<>
			{data?.description && (
				<p className="large-text">
					{data.description}
				</p>
			)}
			<div className="margin-bottom-24 margin-top-16">
				<h3>Attributes</h3>
				<Tile>
					<>
						{data?.division && (
							<div className="margin-bottom-8">
								<strong>Division: </strong>
								{data.division}
							</div>
						)}
						{data.classifications?.length > 0 && (
							<div className="margin-bottom-8">
								<strong>Classifications: </strong>
								{data.classifications.map((item, i, { length }) => (
									length - 1 === i ? (
										`${item.label}`
									) : (
										`${item.label}, `
									)
								))}
							</div>
						)}
						{data?.interfaceType && (
							<div className="display-inline-block margin-right-32">
								<strong>Type: </strong>
								{data.interfaceType?.name}
							</div>
						)}
						{data?.version && (
							<div className="display-inline-block margin-right-32">
								<strong>Version: </strong>
								{data.version}
							</div>
						)}
						{data?.owner && (
							<div className="display-inline-block margin-right-32">
								<strong>Owner: </strong>
								{getOwner(data.owner)}
							</div>
						)}
						<div className="display-inline-block margin-right-32">
							<strong>Last updated: </strong>
							{formatDateForDisplay(data.dateUpdated)}
						</div>
					</>
				</Tile>
			</div>
			{data?.storefront && data?.storefront !== null && data?.storefront !== '' && data?.storefront !== 'soon:' ? (
				<div className="border-bottom padding-bottom-24 margin-bottom-24">
					{Object.keys(storefrontData).length !== 0 && (
						<div className="margin-bottom-24">
							<h3>Deployment</h3>
							<Tile>
								<>
									<div className="display-inline-block margin-right-32">
										<strong>Runtime: </strong>
										{storefrontData.runtime}
									</div>
									<div className="display-inline-block margin-right-32">
										<strong>Group: </strong>
										{storefrontData.group}
									</div>
									<div className="display-inline-block margin-right-32">
										<strong>API: </strong>
										{storefrontData.api}
									</div>
								</>
							</Tile>
						</div>
					)}
					{uiGeneralConfig?.metrics?.enabled !== false && (
						<Metrics
							id={id}
							title={uiGeneralConfig?.metrics?.label || 'Metrics'}
						/>
					)}
				</div>
			) : null}
			<Comments
				id={id}
			/>
		</>
	);
};

export default About;
